/* Promotional bands. Kept as data so a campaign can be swapped without
   touching a component. */

export type Offer = {
  id: string
  eyebrow: string
  title: string
  body: string
  cta: string
  href: string
  validUntil: string
}

export const OFFERS: Offer[] = [
  {
    id: 'monsoon-markup',
    eyebrow: 'Limited financing offer',
    title: 'Drive your dream car with flexible monthly payments',
    body: 'Eight partner banks quote on one application, Islamic and conventional, on selected 2026 stock — with approval in as little as 48 hours.',
    cta: 'Explore offer',
    href: '/financing',
    validUntil: '2026-09-30',
  },
]

export const FEATURED_OFFER = OFFERS[0]
